import { Component, input } from '@angular/core';

@Component({
  standalone:true,
  selector: 'app-slash-circle-01',
  imports: [],
  templateUrl: './slash-circle-01.html',
  styleUrl: './slash-circle-01.scss',
})
export class SlashCircle01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
